import React from 'react';
import { Row, Col, Typography } from 'antd';
import SearchSelectAll from 'pages/Search/SearchSelectAll/SearchSelectAll';
import { Tabs } from 'pages/Search/SearchForm/consts';
import { OptionalLienParameters } from '..';
import { ResultTypeName } from 'pages/Search/Search.types';

const { Title, Text } = Typography;

const TableHeader: React.FC<{
  title: string;
  items: { isSelected: boolean }[];
  group: string;
  documentType: string;
  tabName: string;
  resultType: ResultTypeName;
  resultItemIndex: number;
  to?: Date;
  from?: Date;
  bookTypeText?: string;
}> = ({
  title,
  items,
  group,
  documentType,
  tabName,
  resultType,
  resultItemIndex,
  to,
  from,
  bookTypeText,
}) => {
  const selected = items.filter((item) => item.isSelected).length;
  const count = items.length;
  const resultNoun = count === 1 ? 'result' : 'results';

  return (
    <Row type="flex" justify="space-between" align="middle">
      <Col>
        <Title level={4}>{title}</Title>
        <Text>
          Your search <OptionalLienParameters from={from} to={to} /> has
          returned {count} {resultNoun} ({selected} selected for print/export)
          <OptionalLienParameters bookTypeText={bookTypeText} />
        </Text>
        {documentType === 'recordedDocuments' &&
          group?.includes('Richmond County') && (
            <Text style={{ color: '#FF0000' }}>
              <br></br>Please note: results for Richmond County only include
              documents recorded on ACRIS.
            </Text>
          )}
      </Col>
      <Col>
        {(tabName === Tabs.Property ||
          tabName === Tabs.Name ||
          tabName === Tabs.Multi) && (
          <SearchSelectAll
            selected={selected}
            count={count}
            resultItemIndex={resultItemIndex}
            documentType={documentType}
            tabName={tabName}
            resultType={resultType}
          />
        )}
      </Col>
    </Row>
  );
};

export default TableHeader;
